module.exports = __webpack_public_path__ + "triangles.2b5e4605.png";